export const forwardParams = (href: string) => {
  if (typeof window === 'undefined') return href

  const searchParams = new URLSearchParams(window.location.search).toString()

  const hrefHasParams = href.includes('?')

  return `${href}${searchParams ? `${hrefHasParams ? '&' : '?'}${searchParams}` : ''}`
}
